import { render, staticRenderFns } from "./TriggerButtonSection.vue?vue&type=template&id=626ac2b6"
import script from "./TriggerButtonSection.vue?vue&type=script&lang=js"
export * from "./TriggerButtonSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports